let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("10YQF")).then(() => parcelRequire('6bYmv'));